export default __webpack_public_path__ + "static/google-play-download-394ca35f45c6e1611dcc764033734d4a.png";